import { getAPIDataReturn } from "../../../utils/apiFunction";


const getPreview = async (id, abortController, setLoading, setData) => {
        setLoading(true);
        const uri = process.env.REACT_APP_BASE_URL;
    const response = await getAPIDataReturn(('/SalesOrder/SalesOrderPreview?SalesOrderId=' + id), abortController);
        setData(response);
        setLoading(false);
}

export default getPreview;